import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useAuth } from "../auth";
import { TripCtx } from "./TripLayout";
import { Sparkles } from "lucide-react";

export default function ItineraryPage() {
  const { tripId } = useParams();
  const { API, authHeaders } = useAuth();
  const { trip } = useContext(TripCtx);
  const [items, setItems] = useState([]);
  const [activeDay, setActiveDay] = useState(1);

  useEffect(() => {
    axios.get(`${API}/trips/${tripId}/itinerary`, { headers: authHeaders }).then((r) => setItems(r.data));
  }, [tripId]);

  const days = Array.from({ length: Math.max(...items.map((i) => i.day), 1) }, (_, i) => i + 1);
  const dayItems = items.filter((i) => i.day === activeDay);

  return (
    <div data-testid="itinerary-page" className="py-4">
      <p className="tcm-eyebrow">{trip.destination}</p>
      <h1 className="font-display text-4xl mt-2">Itinerary</h1>
      <hr className="tcm-gold-rule w-16 my-6" />
      <div className="flex gap-2 overflow-x-auto pb-4 mb-4">
        {days.map((d) => (
          <button data-testid={`day-tab-${d}`} key={d} onClick={() => setActiveDay(d)}
            className={`tcm-day-circle flex-shrink-0 ${activeDay === d ? "bg-[#1E2D50] text-[#F5EFE6]" : ""}`}
            style={activeDay === d ? { color: "var(--tcm-cream)" } : {}}>{d}</button>
        ))}
      </div>
      <div className="space-y-6">
        {dayItems.length === 0 && <p className="text-sm text-[color:var(--tcm-navy-70)] py-6">No plans yet for this day.</p>}
        {dayItems.map((it) => (
          <div key={it.id} className="tcm-double-frame">
            <div className="tcm-inner p-5">
              {it.magic_touch && !it.hidden && (
                <p className="tcm-eyebrow flex items-center gap-2" style={{color: "var(--tcm-gold)"}}>
                  <Sparkles size={12} /> Magic Touch
                </p>
              )}
              {it.hidden ? (
                <div className="py-4 text-center">
                  <Sparkles size={24} strokeWidth={1.25} style={{color: "var(--tcm-gold)"}} className="mx-auto" />
                  <p className="font-display text-2xl mt-3">{it.title}</p>
                  <p className="tcm-eyebrow mt-2" style={{color: "var(--tcm-gold)"}}>Reveals on the day</p>
                </div>
              ) : (
                <>
                  <p className="tcm-eyebrow mt-1">{it.time || "Anytime"}{it.location ? ` · ${it.location}` : ""}</p>
                  <p className="font-display text-2xl mt-1">{it.title}</p>
                  {it.description && <p className="text-sm mt-2 text-[color:var(--tcm-navy-70)]">{it.description}</p>}
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
